import { StyledPaginationContainer } from "./styled-components";
import { ChannelData } from "./types";
import { Pagination } from "@kaltura/ds-react-components";
import { ChangeEvent } from "react";
import { NoResults } from "./NoResults";
import CardsContainer from "./cards-container/CardsContainer";
import { SearchResultsDisplayComponentProps } from "@kaltura/mediaspace-shared-search";

export type SearchResultsProps = SearchResultsDisplayComponentProps<{ channels: ChannelData[]; totalCount: number }>;

const SearchResults = (props: SearchResultsProps) => {
    const { fetchModuleData, page = 1, onPageChange, pageSize, isTextSearch } = props;
    const { data } = fetchModuleData();

    // show pager
    const showPager = data.totalCount > data.channels.length;
    const pageCount = Math.ceil((data.totalCount ?? 0) / pageSize);

    // handle pager change
    const handleChange = (event: ChangeEvent<unknown>, value: number) => {
        onPageChange(value);
    };

    return (
        <div>
            {data.channels.length > 0 && <CardsContainer channels={data.channels} />}

            {(!data || data.channels.length === 0) && <NoResults isKeywordSearch={isTextSearch} />}

            {showPager && (
                <StyledPaginationContainer className="kms-ds-channels-pagination">
                    <Pagination count={pageCount} page={page} onChange={handleChange} />
                </StyledPaginationContainer>
            )}
        </div>
    );
};

export default SearchResults;
